import { useMemo, useState } from "react";
import { collectionFeed } from "@/mocks/gua";
import SectionTitle from "./SectionTitle";

export default function Collection() {
  const tags = useMemo(() => {
    const set = Array.from(new Set(collectionFeed.map((it) => it.tag)));
    return ["全部", ...set];
  }, []);
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () => (active === "全部" ? collectionFeed : collectionFeed.filter((it) => it.tag === active)),
    [active]
  );

  return (
    <section id="collection" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-5 md:flex-row md:items-end">
          <SectionTitle
            eyebrow="新近合集"
            title="最近的新瓜，一网打尽"
            desc="按类型切换，只看你关心的那部分：影视、综艺、品牌还是社媒话题，随点随看。"
          />
          <div className="flex flex-wrap items-center gap-2 rounded-full bg-background-50 p-1 shadow-sm">
            {tags.map((tag) => (
              <button
                key={tag}
                type="button"
                onClick={() => setActive(tag)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-bold transition-colors ${
                  active === tag
                    ? "bg-primary-500 text-white"
                    : "text-foreground-700 hover:bg-background-200/70"
                }`}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-2xl bg-white transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-bold text-white">
                  {item.tag}
                </span>
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-black/40 px-2 py-0.5 text-[11px] font-bold text-white">
                  <i className="ri-fire-fill text-accent-300" aria-hidden="true" />
                  {item.hot}%
                </span>
              </div>
              <div className="flex flex-1 flex-col gap-2 p-4">
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>更新于 {item.date}</span>
                  <span>{item.source}</span>
                </div>
                <h3 className="line-clamp-2 font-heading text-base font-black leading-snug text-foreground-900">
                  {item.title}
                </h3>
                <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}